import React, { useEffect } from 'react';
import { connect } from "react-redux";
import PreguntasFrecuentes from "../../components/PreguntasFrecuentes/PreguntasFrecuentes";
import { preguntasFrecuentesFetch } from "../../redux/actions/aPreguntasFrecuentes";

const ContainerPreguntasFrecuentes = (props) => {
  useEffect(() => {
    if (!props.datosPreguntasFrecuentes || props.datosPreguntasFrecuentes.PreguntasFrecuentes.length === 0)
      props.listarPreguntasFrecuentes();
  }, []);

  return (
    <main className="cr-app bg-light">
      <div className="cr-content container-fluid">
        <div className="container-body-spaces">
          <PreguntasFrecuentes datosPreguntasFrecuentes={props.datosPreguntasFrecuentes} />
        </div>
      </div>
    </main>
  );

}


const mapStateToProps = state => ({
  datosPreguntasFrecuentes: state.datosPreguntasFrecuentes
});

const mapDispatchToProps = dispatch => {
  return {
    listarPreguntasFrecuentes: () => dispatch(preguntasFrecuentesFetch()),
  };
};

export default
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerPreguntasFrecuentes);
